const key = "add-vessel-field-data";

const applicable = (resp) => {
	return resp.config.method === "GET" && resp.config.url.match(/api\/forms\/131$/);
};

const extendedProperties = {
	Engine: {
		Horsepower: 100
	},
	Electronics: {
		SideScanSonar: true,
		Fathometer: false
	},
	Lighting: {
		AttractingLightsUsed: [
			{
				type: "Type 1",
				wattage: 50,
				number: 2
			},
			{
				type: "Type 2",
				wattage: 100,
				number: 1
			}
		]
	}
};

const modify = (resp) => {
	const vesselField = resp.data.Data.Fields.find(field => field.Key.Code === "REPORT.ENTITIES.VESSEL.SINGLE");

	if(vesselField?.Data) {
		vesselField.Data = vesselField.Data.map(dataItem => ({
			...dataItem,
			...extendedProperties
		}));
	}

	return resp;
};

export const addVesselFieldData = [key, applicable, modify];